import React from 'react';

export const StripeSearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fillRule="evenodd" clipRule="evenodd" d="M5 6H35V36H5V6Z" fill="#635BFF" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.8301 17.662C18.8301 16.957 19.4076 16.6795 20.3676 16.6795C21.7476 16.6795 23.4876 17.0995 24.8676 17.842V13.582C23.3601 12.982 21.8751 12.7495 20.3751 12.7495C16.6926 12.7495 14.2476 14.6695 14.2476 17.8795C14.2476 22.882 21.1401 22.087 21.1401 24.247C21.1401 25.0795 20.4126 25.3495 19.4001 25.3495C17.8926 25.3495 15.9726 24.7345 14.4501 23.902V28.2145C16.1376 28.942 17.8401 29.2495 19.4001 29.2495C23.1726 29.2495 25.7676 27.382 25.7676 24.1345C25.7376 18.7345 18.8301 19.6945 18.8301 17.662Z"
			fill="white"
		/>
	</svg>
);
